import {
  Datagrid,
  NumberField,
  TextField,
  TopToolbar,
  ShowButton,
  Filter,
  NumberInput,
  TextInput,
} from "react-admin";
import { DateField, CustomList } from "../../../shared/components/index.js";

const DatexTransactionFilter = (props) => (
  <Filter {...props}>
    <TextInput source="fn_card_owner" alwaysOn />
    <TextInput source="n_accounts_struc" alwaysOn />
    <TextInput source="code_edroup_card_owner" alwaysOn />
    <NumberInput source="amount" alwaysOn />
  </Filter>
);

const DatexTransactionList = (props) => (
  <CustomList
    filters={<DatexTransactionFilter {...props} />}
    actions={<TopToolbar />}
  >
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source="fn_card_owner" />
      <TextField source="code_edroup_card_owner" />
      <NumberField source="amount" />
      <NumberField source="sum" />
      <TextField source="n_accounts_struc" />
      <TextField source="n_service_station" />
      <TextField source="address" />
      <TextField source="n_issuers" />
      <NumberField source="confirm_status" />
      <DateField source="session_time" />
      <ShowButton className="button-show" />
    </Datagrid>
  </CustomList>
);

export default DatexTransactionList;
